import * as yup from 'yup'

const schema = yup.object().shape({
  beneficiarySebrae: yup.boolean(),
  responsableUserCpf: yup.string().cpf(),
})

export default schema
